<template>
  <v-container fluid class="background-bg full-height">
    <v-row justify="center" align="center" class="mt-12">
      <v-col cols="12" sm="6" lg="3" md="4">
        <v-card class="pa-4 d-flex flex-column align-center">
          <div class="mt-2">
            <img class="card-logo" src="../assets/enel_foundation_logo.png" />
          </div>

          <div class="title mt-12 primaryText--text">Verification Code</div>
          <div class="secondaryText--text body-2 ma-2">We sent a vertification code to your Email</div>

          <v-form
            @submit.prevent="onVerifyCode"
            class="px-4 mt-4 align-self-stretch d-flex flex-column"
          >
            <v-text-field
              class="title"
              v-model="code"
              name="code"
              @blur="$v.code.$touch"
              required
              single-line
              placeholder="Enter 6 Digit Code"
            />

            <v-alert v-if="hasError" type="error" class="caption pa-1 mt-4">{{ this.errorMessage }}</v-alert>

            <v-btn
              class="mt-12 mx-12"
              :disabled="$v.$invalid"
              type="submit"
              color="accent"
              :loading="loading"
              :value="code"
            >Verify</v-btn>
            <div
              class="caption primaryText--text mt-6 text-center">
              Kind Note: if you do not receive the verification email within 5 minutes, 
              please contact our
              <a href="mailto:customersupport@beezsocialerp.com">Support Team </a>
            </div>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>


<script>
import { required, maxLength, minLength } from "vuelidate/lib/validators";
import { mapFields } from "vuex-map-fields";
import { mapActions } from "vuex";

export default {
  name: "EmailVerification",
  data() {
    return {
      code: "",
      loading: false,
      errorMessage: ""
    };
  },
  async created() {
    const { email } = this.currentUser;
    if (email) {
      await this.sendVerificationCode(email);
    }
  },
  computed: {
    ...mapFields("auth", [
      "currentUser",
      "currentUser.isVerified",
      "currentUser.email"
    ]),
    hasError() {
      return this.errorMessage && this.errorMessage.length;
    }
  },
  validations: {
    code: {
      required,
      minLength: minLength(6),
      maxLength: maxLength(6)
    }
  },
  methods: {
    ...mapActions("verification", {
      sendVerificationCode: "sendVerificationCode",
      verifyCode: "verifyCode"
    }),

    async onVerifyCode() {
      this.loading = true;
      try {
        await this.verifyCode({ email: this.email, code: this.code });
        // set user is verified
        // this will update the store
        // because we are using mapFields
        this.isVerified = true;


        // user is verified. we can go to the next screen
        this.$router.replace({
          name: "instructions"
        });
      } catch (error) {

        
        this.errorMessage = error.message;
        setTimeout(() => {
          this.errorMessage = "";
        }, 2000);
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>